module.exports = __webpack_public_path__ + "static/media/close-material.648eb552.svg";